'use strict'

const includes_ = require('lodash/includes')
const { Button, IconButton } = require('dbsm-common/src/componentTypes')
const LINKABLE_COMPONENTS = [Button, IconButton]

module.exports = component => includes_(LINKABLE_COMPONENTS, component.type)



// WEBPACK FOOTER //
// ./helpers/isLinkableDisableableComponent.js